import * as THREE from "../../../libs/three.js/build/three.module.js";
import { EventDispatcher } from "../../EventDispatcher.js";
import {TextSprite} from "../../TextSprite.js";

let sg = new THREE.SphereGeometry(1, 8, 8);
	let sgHigh = new THREE.SphereGeometry(1, 128, 128);

	let sm = new THREE.MeshBasicMaterial({side: THREE.BackSide});
	let smHovered = new THREE.MeshBasicMaterial({side: THREE.BackSide, color: 0xff0000});

	let raycaster = new THREE.Raycaster();
	let currentlyHovered = null;
	let currentlySelected = null;
	let ImNotFocused = true;
	let previousSelected = null;
 	let defaultControls = null;
	let arrayImages360= [];
	let arrayNodes = [];
	let indiceSeleccion = null;
	let nubeOculta = false;


	let previousView = {
		controls: null,
		position: null,
		target: null,
	};
	

	class Image360{

		constructor(file, time, longitude, latitude, altitude, course, pitch, roll, index){
			this.file = file;
			this.time = time;
			this.longitude = longitude;
			this.latitude = latitude;
			this.altitude = altitude;
			this.course = course;
			this.pitch = pitch;
			this.roll = roll;
			this.mesh = null;
			this.index = index;
		}
	};

	export class Images360 extends EventDispatcher{

		constructor(viewer){
			super();

			this.viewer = viewer;


			defaultControls = this.viewer.getControls();

			this.selectingEnabled = true;

			this.images = [];
			this.node = new THREE.Object3D();

			this.sphere = new THREE.Mesh(sgHigh, sm);
			this.sphere.visible = false;
			this.sphere.scale.set(0.2, 0.2, 0.2);
			this.node.add(this.sphere);
			this._visible = true;
			// this.node.add(label);

			this.focusedImage = null;
			
			let nextPosition = document.createElement("input");
				nextPosition.type = "button";
				nextPosition.value = "▶";  // Usamos el icono de "siguiente"
				nextPosition.style.position = "absolute";
				nextPosition.style.left = "55px";
				nextPosition.style.bottom = "10px";
				nextPosition.style.zIndex = "10000";
				nextPosition.style.fontSize = "2em";
				nextPosition.style.backgroundColor = "rgba(0, 0, 255, 0.8)";  // Azul con opacidad
				nextPosition.style.color = "white";  // Color del texto en blanco
				nextPosition.style.border = "none";
				nextPosition.style.borderRadius = "8px";  // Bordes redondeados
				nextPosition.style.padding = "10px";
				nextPosition.style.cursor = "pointer";
				nextPosition.style.transition = "all 0.3s ease";

				nextPosition.addEventListener("click", () => this.updatePosition(indiceSeleccion, nextPosition.value));
				this.nextPosition = nextPosition;
				this.domRoot = viewer.renderer.domElement.parentElement;
				this.domRoot.appendChild(nextPosition);
				this.nextPosition.style.display = "none";


				let previousPosition = document.createElement("input");
				previousPosition.type = "button";
				previousPosition.value = "◀";  // Usamos el icono de "anterior"
				previousPosition.style.position = "absolute";
				previousPosition.style.left = "10px";
				previousPosition.style.bottom = "10px";
				previousPosition.style.zIndex = "10000";
				previousPosition.style.fontSize = "2em";
				previousPosition.style.backgroundColor = "rgba(0, 0, 255, 0.8)";
				previousPosition.style.color = "white";
				previousPosition.style.border = "none";
				previousPosition.style.borderRadius = "8px";
				previousPosition.style.padding = "10px";
				previousPosition.style.cursor = "pointer";
				previousPosition.style.transition = "all 0.3s ease";
				
				previousPosition.addEventListener("click", () => this.updatePosition(indiceSeleccion, previousPosition.value));
				this.previousPosition = previousPosition;
				this.domRoot = viewer.renderer.domElement.parentElement;
				this.domRoot.appendChild(previousPosition);
				this.previousPosition.style.display = "none";


				let elUnfocus = document.createElement("input");
				elUnfocus.type = "button";
				elUnfocus.value = "❌";  // Usamos el icono de "unfocus" o "detener"
				elUnfocus.style.position = "absolute";
				elUnfocus.style.right = "10px";
				elUnfocus.style.bottom = "10px";
				elUnfocus.style.zIndex = "10000";
				elUnfocus.style.fontSize = "2em";
				elUnfocus.style.backgroundColor = "rgba(0, 0, 255, 0.8)";
				elUnfocus.style.color = "white";
				elUnfocus.style.border = "none";
				elUnfocus.style.borderRadius = "8px";
				elUnfocus.style.padding = "10px";
				elUnfocus.style.cursor = "pointer";
				elUnfocus.style.transition = "all 0.3s ease";
				elUnfocus.addEventListener("click", () => this.unfocus());
				this.elUnfocus = elUnfocus;
				this.domRoot = viewer.renderer.domElement.parentElement;
				this.domRoot.appendChild(elUnfocus);
				this.elUnfocus.style.display = "none";


				let mostrarImagen = document.createElement("input");
				mostrarImagen.type = "button";
				mostrarImagen.value = "📷";  // Usamos el icono de "visor"
				mostrarImagen.style.position = "absolute";
				mostrarImagen.style.right = "85px";
				mostrarImagen.style.bottom = "10px";
				mostrarImagen.style.zIndex = "10000";
				mostrarImagen.style.fontSize = "2em";
				mostrarImagen.style.backgroundColor = "rgba(0, 0, 255, 0.8)";
				mostrarImagen.style.color = "white";
				mostrarImagen.style.border = "none";
				mostrarImagen.style.borderRadius = "8px";
				mostrarImagen.style.padding = "10px";
				mostrarImagen.style.cursor = "pointer";
				mostrarImagen.style.transition = "all 0.3s ease";
				
				mostrarImagen.addEventListener("click", () => {
					nubeOculta = true;
					this.sphere.visible = true;
					this.mostrarNube.style.display = "";
					this.mostrarImagen.style.display = "none";

				});
				this.mostrarImagen = mostrarImagen;
				this.domRoot = viewer.renderer.domElement.parentElement;
				this.domRoot.appendChild(mostrarImagen);
				this.mostrarImagen.style.display = "none";

				let mostrarNube = document.createElement("input");
				mostrarNube.type = "button";
				mostrarNube.value = "🌐";  // Usamos el icono de "nube"
				mostrarNube.style.position = "absolute";
				mostrarNube.style.right = "85px";
				mostrarNube.style.bottom = "10px";
				mostrarNube.style.zIndex = "10000";
				mostrarNube.style.fontSize = "2em";
				mostrarNube.style.backgroundColor = "rgba(0, 0, 255, 0.8)";
				mostrarNube.style.color = "white";
				mostrarNube.style.border = "none";
				mostrarNube.style.borderRadius = "8px";
				mostrarNube.style.padding = "10px";
				mostrarNube.style.cursor = "pointer";
				mostrarNube.style.transition = "all 0.3s ease";
				mostrarNube.addEventListener("click", () => {
					nubeOculta = false;
					this.sphere.visible = false;
					this.mostrarNube.style.display = "none";
					this.mostrarImagen.style.display = "";
				});
				this.mostrarNube = mostrarNube;
				this.domRoot = viewer.renderer.domElement.parentElement;
				this.domRoot.appendChild(mostrarNube);
				this.mostrarNube.style.display = "none";





			viewer.addEventListener("update", () => {
				this.update(viewer);
			});
			viewer.inputHandler.addInputListener(this);

			this.addEventListener("mousedown", () => 
			 {
				this.handlerSelected();
				//console.log("dentromouseup");

				if(currentlySelected){
					//console.log("currentlySelecrted.image360:",currentlySelected.image360);
					if(currentlySelected.userData.isInteractable){
					this.focus(currentlySelected.image360);
					}
					//console.log("mouseupcurrently");
					//console.log("scale2", currentlySelected.scale)
					//currentlySelected.visible = false;
					//currentlySelected.visible = false;

					//currentlySelected = intersection.object;
					
					//console.log(currentlyHovered.material.visible);
				}
			});
			
		};

		set visible(visible){
			if(this._visible === visible){
				return;
			}


			for(const image of this.images){
				image.mesh.visible = visible && (this.focusedImage == null);
			}

			this.sphere.visible = visible && (this.focusedImage != null);
			this._visible = visible;
			this.dispatchEvent({
				type: "visibility_changed",
				images: this,
			});
		}

		get visible(){
			return this._visible;
		}

		focus(image360){
			
			if(this.focusedImage !== null){
				this.unfocus();
			}
			//console.log("arrayNodes", arrayNodes);
			currentlySelected.userData.isInteractable = false;
			previousSelected = currentlySelected;
			indiceSeleccion = currentlySelected.image360.index;
			nubeOculta = true;
			
			ImNotFocused = false;
			previousView = {
				controls: this.viewer.controls,
				position: this.viewer.scene.view.position.clone(),
				target: viewer.scene.view.getPivot(),
			};

			this.viewer.setControls(this.viewer.orbitControls);
			this.viewer.orbitControls.doubleClockZoomEnabled = false;

			for(let image of this.images){
				image.mesh.visible = true;
			}

			this.selectingEnabled = false;

			//this.sphere.visible = true;
			currentlySelected.visible = false;
			

			console.log("currently selected:",currentlySelected);
			//currentlySelected.mesh.material.color.setRGB(0,0,0);

			

			this.load(image360).then( () => {
				
				this.sphere.visible = true;
				this.sphere.material.map = image360.texture;
				this.sphere.material.needsUpdate = true;							
			});

			{ // orientation
				let {course, pitch, roll} = image360;
				this.sphere.rotation.set(
					THREE.Math.degToRad(+roll + 90),
					THREE.Math.degToRad(-pitch),
					THREE.Math.degToRad(-course + 28),
					"ZYX"
				);
			}

			this.sphere.position.set(...image360.position);

			let target = new THREE.Vector3(...image360.position);
			let dir = target.clone().sub(viewer.scene.view.position).normalize();
			let move = dir.multiplyScalar(0.000001);
			let newCamPos = target.clone().sub(move);

			viewer.scene.view.setView(
				newCamPos, 
				target,
				500
			);

			this.focusedImage = image360;

			this.elUnfocus.style.display = "";
			this.nextPosition.style.display = "";
			this.previousPosition.style.display = "";
			if(nubeOculta == false){
				this.mostrarImagen.style.display = "";
				this.mostrarNube.style.display = "none";
			}else if(nubeOculta == true){
				this.mostrarImagen.style.display = "none";
				this.mostrarNube.style.display = "";
			}
		}


		updatePosition(indiceSeleccion, nextPositionValue) {

			//console.log("indiceSeleccion",indiceSeleccion);
			//console.log("nextPositionValue", nextPositionValue);
    	// Verificar que el índice esté dentro de los límites
    		if (indiceSeleccion < 0 || indiceSeleccion > arrayNodes.lenght) {

        		console.error("Índice fuera de los límites");
				
				return;
    		}
			else if(nextPositionValue == "◀"){
				indiceSeleccion--;
				console.log("indiceSeleccion:<", indiceSeleccion);
				currentlySelected = arrayNodes[indiceSeleccion];
    			this.focus(arrayNodes[indiceSeleccion].image360);
				console.log(arrayNodes[indiceSeleccion].image360);
				return;
			
			}else if(nextPositionValue == "▶"){
				indiceSeleccion++;
				console.log("indiceSeleccion:>", indiceSeleccion);
				currentlySelected = arrayNodes[indiceSeleccion];
				this.focus(arrayNodes[indiceSeleccion].image360);
				console.log(arrayNodes[indiceSeleccion].image360);
				return;
			}

    		// Ocultar la esfera del nuevo posicionamiento
    		//image360.mesh.visible = false;
		}
	

		unfocus(){
			previousSelected.userData.isInteractable = true;
			this.selectingEnabled = true;
			currentlySelected.visible = true;

			ImNotFocused = true;

			for(let image of this.images){
				image.mesh.visible = true;
			}

			let image = this.focusedImage;

			if(image === null){
				return;
			}


			//this.sphere.material.map = null;
			//this.sphere.material.needsUpdate = true;
			//this.sphere.visible = true;

			let pos = viewer.scene.view.position;
			let target = viewer.scene.view.getPivot();
			let dir = target.clone().sub(pos).normalize();
			let move = dir.multiplyScalar(10);
			let newCamPos = target.clone().sub(move);

			viewer.orbitControls.doubleClockZoomEnabled = true;
			viewer.setControls(this.viewer.orbitControls);
			//console.log("previousView.position", previousView.position);
			//console.log("previousView.target", previousView.target);

			previousView.position.x = previousView.position.x - 1;
			previousView.position.y = previousView.position.y - 1;
			previousView.target.x = previousView.target.x - 5;
			previousView.target.y = previousView.target.y -1;
			
			viewer.scene.view.setView(
				previousView.position, 
				previousView.target,
				500
			);

			this.focusedImage = null;
			this.elUnfocus.style.display = "none";
			this.nextPosition.style.display = "none";
			this.previousPosition.style.display = "none";
			this.mostrarImagen.style.display = "none";
			this.mostrarNube.style.display = "none";
		}

		load(image360){
	
			return new Promise(resolve => {
				let texture = new THREE.TextureLoader().load(image360.file, resolve);
				texture.wrapS = THREE.RepeatWrapping;
				texture.repeat.x = -1;
				image360.texture = texture;
				//console.log("valuesReturned:", image360);
			});

		}
		handlerSelected(){
			
			
			let mouse = viewer.inputHandler.mouse;
			let camera = viewer.scene.getActiveCamera();
			let domElement = viewer.renderer.domElement;

			let ray = Potree.Utils.mouseToRay(mouse, camera, domElement.clientWidth, domElement.clientHeight);

			raycaster.ray.copy(ray);
			let intersections = raycaster.intersectObjects(this.node.children);
			if(intersections.length === 0){
				// label.visible = false;
				return;
			}
			let intersection = intersections[0];
			currentlySelected = intersection.object;
			//console.log("currentlySelected: ", currentlySelected);
			//console.log("currentlySelected.image360", currentlySelected.image360);

		}


		/*handleHovering(){
			let mouse = viewer.inputHandler.mouse;
			let camera = viewer.scene.getActiveCamera();
			let domElement = viewer.renderer.domElement;

			let ray = Potree.Utils.mouseToRay(mouse, camera, domElement.clientWidth, domElement.clientHeight);

			// let tStart = performance.now();
			raycaster.ray.copy(ray);
			let intersections = raycaster.intersectObjects(this.node.children);
			if(intersections.length === 0){
				// label.visible = false;
				return;
			}

			let intersection = intersections[0];
			currentlyHovered = intersection.object;
			currentlyHovered.material = smHovered;
			
			

			//label.visible = true;
			//label.setText(currentlyHovered.image360.file);
			//currentlyHovered.getWorldPosition(label.position);
		}*/

		update(){

			let {viewer} = this;
			/*if(currentlySelected){
			console.log("mesh", currentlySelected.scale);
			console.log("clickable", currentlySelected.isMesh
			}*/
			if(currentlyHovered){
				currentlyHovered.material = sm;
				currentlyHovered = null;
			}
			if(ImNotFocused)
			{
				//previousSelected = currentlySelected;
				currentlySelected = null;
			}
			/*if(this.selectingEnabled){
				this.handleHovering();
			}*/
		}
	};


	export class Images360Loader{

		static async load(url, viewer, params = {}){

			if(!params.transform){
				params.transform = {
					forward: a => a,
				};
			}

			let response = await fetch(`${url}/coordinates.txt`);
			let text = await response.text();


			let lines = text.split(/\r?\n/);
			let coordinateLines = lines.slice(1);
			let returnValues = [];
		

			let images360 = new Images360(viewer);

			let indice = 0;

			for(let line of coordinateLines){
				

				if(line.trim().length === 0){
					continue;
				}
				//console.log(indice);
				
				

				let tokens = line.split(/\t/);

				let [filename, time, long, lat, alt, course, pitch, roll, index] = tokens;
				time = parseFloat(time);
				long = parseFloat(long);
				lat = parseFloat(lat);
				alt = parseFloat(alt);
				course = parseFloat(course);
				pitch = parseFloat(pitch);
				roll = parseFloat(roll);
				index = parseFloat(index);

				filename = filename.replace(/"/g, "");
				let file = `${url}/${filename}`;

				let image360 = new Image360(file, time, long, lat, alt, course, pitch, roll, index);

				let xy = params.transform.forward([long, lat]);
				let position = [...xy, alt];
				image360.position = position;

				images360.images.push(image360);
				arrayImages360[indice] = image360;
				indice++;
			}

			Images360Loader.createSceneNodes(images360, params.transform);

			returnValues = [images360, arrayNodes];
			return images360;
		}

		


		static createSceneNodes(images360, transform){
			let indiceNodes = 0;

			for(let image360 of images360.images){
				

				let {longitude, latitude, altitude} = image360;
				let xy = transform.forward([longitude, latitude]);

				let mesh = new THREE.Mesh(sg, sm);
				mesh.position.set(...xy, altitude);
				mesh.scale.set(0.2, 0.2, 0.2);
				mesh.material.transparent = true;
				mesh.material.opacity = 0.8;
				//mesh.material.color.setRGB(1, 0, 0);
				mesh.image360 = image360;
				mesh.userData.isInteractable = true;

				{ // orientation
					var {course, pitch, roll} = image360;
					mesh.rotation.set(
						THREE.Math.degToRad(+roll),
						THREE.Math.degToRad(-pitch),
						THREE.Math.degToRad(-course),
						"ZYX"
					);
				}

				images360.node.add(mesh);
				image360.mesh = mesh;
				arrayNodes[indiceNodes]= mesh;
				//console.log(arrayNodes[indiceNodes]);
				indiceNodes++;
			}
			return {arrayNodes, arrayNodes};
			
		}

		

	};





